import { subscribeChannel, publishChannel } from './channelUtils';

export function sendOccurrences(occurrences) {

    publishChannel('trip-occurrences', occurrences);

}

export function sendUpsertOccurrence(occurrence) {

    publishChannel('trip-occurrence-upsert', occurrence);

}

export function sendRemoveOccurrence({
    tripUid,
    occurrenceUid
}) {

    publishChannel(
        'trip-occurrence-remove',
        {
            tripUid,
            occurrenceUid
        }
    );

}

export function listenOccurrences(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'trip-occurrences' &&
            tipo !== 'trip-occurrence-upsert' &&
            tipo !== 'trip-occurrence-remove'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}